import React from 'react';
import PropTypes from 'prop-types';
const sortBy = require('lodash/sortBy');

import ActionListItem from './ActionListItem';

const propTypes = {
    className: PropTypes.string,
    actions: PropTypes.arrayOf(PropTypes.object),
    actionHeading: PropTypes.string,
    visible: PropTypes.bool,
    hideMenu: PropTypes.func,
    channels: PropTypes.arrayOf(PropTypes.element),
    organizations: PropTypes.arrayOf(PropTypes.element)
};

const defaultProps = {
    className: '',
    actions: [],
    channels: [],
    organizations: [],
    visible: true,
    hideMenu: null
};

function SideMenu(props) {
    function handleAction(action) {
        if (props.hideMenu) props.hideMenu();
        if (action) action();
    }

    return (
        <div className={`side-menu ${props.className} mzl-cs-nav`}>
            {props.organizations.length > 0 &&
                <div>
                    <h3 className="nav-category-title">
                        organizations
                    </h3>
                    <div className="nav-list channel-list">
                        {props.organizations}
                    </div>
                </div>
            }
            {props.channels.length > 0 &&
                <div>
                    <h3 className="nav-category-title top">
                        channels
                    </h3>
                    <div className="nav-list channel-list">
                        {props.channels}
                    </div>
                </div>
            }
            <div className="nav-list action-list">
                {props.actionHeading &&
                    <h3 className="nav-category-title">{props.actionHeading}</h3>
                }
                {sortBy(props.actions, "group").map((action) => 
                    <ActionListItem
                        onClick={handleAction.bind(null, action.handler)}
                        text={action.value}
                        highlight={action.highlight}
                        showSelected={action.show_selected}
                        key={action.value}
                    />
                )}
            </div>
        </div>
    );
}

SideMenu.propTypes = propTypes;
SideMenu.defaultProps = defaultProps;

export default SideMenu;
